import { APGenericSlot } from '../../../builders/ap_generic_slot_builder';
import { RouterHelper } from '../../../helpers/router_helper';

export class MarkAsMetFacade {
  constructor(private routerHelper: RouterHelper) {}

  gotoMarkAsMetState(genericSlot: APGenericSlot, stateName: string) {
    return this.routerHelper.findStateAndGo(stateName, { genericSlot });
  }

  markAsMet(genericSlot: APGenericSlot) {
    const markAsMetStateName = '.mark_as_met';
    this.gotoMarkAsMetState(genericSlot, markAsMetStateName);
  }

  markAsUnMet(genericSlot: APGenericSlot) {
    const markAsUnMetStateName = '.mark_as_unmet';
    this.gotoMarkAsMetState(genericSlot, markAsUnMetStateName);
  }
}

angular.module('capability-ng-academic-planner').service('markAsMetFacade', MarkAsMetFacade);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/mark_as_met/facades/mark_as_met_facade.ts